const { scrollmagic } = require("./modules/scrollmagic");
const { pageTop } = require("./modules/pageTop");
const { smooth } = require("./modules/smooth");
const { accordion } = require("./modules/accordion");
const { menu } = require("./modules/menu");

scrollmagic();
pageTop();
smooth();
accordion();
menu();
